import Swiper from 'swiper';

class BlockLastNews {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.last-news__swiper ', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
  }
}

export const blockLastNews = new BlockLastNews();
